import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styles from "./style.module.scss";
const ReasonButton = ({ onClick, label }) => (_jsx("button", { type: "button", className: styles.cancel_button, onClick: onClick, children: label }));
export default ReasonButton;
